import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { useEffect, useState } from "react";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupNoteValidationForm } from "../../utils/validationSchemas";

import PickupNoteForm from "./PickupNoteForm";

const CreatePickupNote = (props: any) => {
  const { handleCreate, isLoading} = props;
  const [senderId, setSenderId] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        piece: 0,
      };
    },
    resolver: yupResolver(createPickupNoteValidationForm),
  });
  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.user_info?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <PickupNoteForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          watch={watch}
          control={control}
          setSenderId={setSenderId}
        />
      </FormLayout>
    </>
  );
};

export default CreatePickupNote;

